import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {AbstractActionService} from '../../../../../../core/service/v2/service/action/abstractAction.service';
import {DateConverter} from "../../../../../../common/converter/date.converter";
import {Moment} from "moment";

@Injectable()
export class ConsultationGetPartnerAnamnesisService extends AbstractActionService<ConsultationGetPartnerAnamnesisPayload, ConsultationGetPartnerAnamnesisDto[]> {

    constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                httpClient: HttpClient,
                private dateConverter: DateConverter) {
        super('Consultation', 'get-partner-anamnesises', customizeHttpUrlGenerator, httpClient);
    }

    protected buildResponse(response: any): ConsultationGetPartnerAnamnesisDto[] {
        return (response as ConsultationGetPartnerAnamnesisDto[]).map(value => {
            const dto = new ConsultationGetPartnerAnamnesisDto();
            dto.anamnesis = value.anamnesis;
            dto.date = this.dateConverter.convert(value.date);
            dto.id = value.id;
            return dto;
        })
    }

}

export class ConsultationGetPartnerAnamnesisPayload {
    partnerId: number;
}

export class ConsultationGetPartnerAnamnesisDto {
    anamnesis: string;
    date: Moment;
    id: number;

    get formattedAnamnesis(): string {
        return ConsultationGetPartnerAnamnesisDto.formatAnamnesis(this.anamnesis)
    }

    static formatAnamnesis(anamnesis: string): string {
        if (!anamnesis) {
            return undefined;
        }
        return anamnesis
            .replace(/&lt;br\s*\/?&gt;/g, '<br>')
            .replace(/\[S1\]/g, '<strong>Praticien :</strong>')
            .replace(/\[S2\]/g, '<strong>Patient :</strong>')
            .replace(/(<br\s*\/?>\s*){2,}/g, '<br><br>');
    }
}